import React from "react";
import LazyLoad from "react-lazyload";
import Image from "@default/general-components/image/image";

const TeaserVenueImage = ({ item }) => {
  return (
    <div className="image">
      {item.fieldImage && (
        <LazyLoad offset={1000}>
          <Image
            data={item.fieldImage.fieldMediaImage}
            credit={item.fieldImage.fieldCredits}
            nodeTitle={item.label}
          />
        </LazyLoad>
      )}
    </div>
  );
}

export default TeaserVenueImage;